// extracted by mini-css-extract-plugin
export default {"change_title":"ChangeTitle_change_title__KVF4g","title":"ChangeTitle_title__oQP+o","title_wrapper":"ChangeTitle_title_wrapper__2bBn-","input":"ChangeTitle_input__UANZI"};